import React from 'react';
import PropTypes from 'prop-types';

import { colorGray } from 'styles/layout/colors';

const IconEdit = ({
  className = '',
  color = colorGray,
  height = 20,
  width = 20,
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 1242.000000 1254.000000"
    {...props}
  >
    <g
      transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)"
      fill={color}
      stroke="none"
    >
      <path
        d="M9908 12130 c-159 -20 -325 -98 -471 -221 -51 -43 -1012 -998 -2137
-2124 -1125 -1126 -2188 -2184 -2364 -2353 -175 -169 -493 -487 -705 -707
-213 -220 -515 -524 -672 -675 -590 -572 -1817 -1796 -1885 -1881 -129 -162
-172 -253 -442 -934 -503 -1269 -662 -1664 -751 -1873 -210 -494 -232 -682
-96 -819 82 -81 169 -99 335 -67 106 20 229 64 580 209 157 65 537 218 845
341 308 122 688 274 845 337 157 63 346 138 420 167 194 75 359 157 485 241
106 71 254 217 3975 3942 2289 2292 3887 3899 3920 3942 128 171 168 287 177
512 6 154 -1 215 -43 347 -48 152 -102 235 -283 441 -280 320 -884 906 -1036
1006 -95 63 -233 127 -320 150 -91 23 -272 33 -377 19z m236 -694 c101 -31
171 -90 554 -470 400 -397 510 -518 551 -606 23 -49 26 -67 26 -165 0 -97 -3
-116 -26 -165 -41 -88 -172 -240 -395 -461 -197 -195 -283 -268 -381 -326
l-42 -24 -43 22 c-24 12 -72 43 -108 70 -69 51 -1233 1221 -1238 1244 -5 20
314 373 523 581 101 99 214 202 253 228 119 81 220 104 326 72z m-1400 -1555
c197 -183 625 -608 934 -929 l214 -221 -378 -383 c-618 -625 -5622 -5625
-5727 -5722 l-97 -88 -133 125 c-187 177 -1187 1185 -1187 1197 0 17 253 273
483 490 330 310 498 478 907 908 206 216 749 762 1207 1214 458 451 974 965
1147 1142 173 176 739 747 1258 1268 836 839 1164 1157 1192 1158 4 0 85 -71
180 -159z m-6184 -7163 c294 -293 536 -536 538 -539 8 -17 -317 -195 -512
-281 -165 -73 -709 -290 -851 -340 -134 -47 -440 -138 -465 -138 -9 0 -10 11
-5 37 13 68 75 276 124 413 89 246 361 920 420 1040 56 112 196 340 209 340 4
0 247 -240 542 -532z"
      />
    </g>
  </svg>
);

IconEdit.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default IconEdit;
